
const tableStyle = {
  marginTop: '25px',
  background: '#f8f8f8',
  borderRadius: '5px',
};

const options = {
  textAlign: 'center',
};

export default {
  tableStyle, options,
};



// WEBPACK FOOTER //
// ./src/scenes/Medication/components/MedicationList/style.js